import React, {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {StyledUnifonWarningDiv, StyledUnifonWarningLayout, StyledUnifonWarningText} from './styled';
import {IconButton, Layout, WarningIcon} from '@phonectas/unifon-ui-kit';
import NewWindowIcon from 'common/components/icons/NewWindowIcon';

type WarningKey = 'one' | 'two' | 'three';

interface Props {
	warnings?: boolean;
}
const CustomerWarnings: React.FC<Props> = ({warnings}) => {
	const [t] = useTranslation();
	const someWarnings: Record<WarningKey, string> = useMemo(() => ({
		one: t('Debt Collection'),
		two: t('Ongoing Churn'),
		three: t('Something Else'),
	}), [t]);
	const someWarningsTwo: Record<'one' | 'two', string> = useMemo(() => ({
		one: t('Debt Collection'),
		two: t('Ongoing Churn'),
	}), [t]);

	const randomWarnings = useCallback(() => {
		const random = Math.floor(Math.random() * 2);
		return random === 0 ? someWarnings : someWarningsTwo;
	}, [someWarnings, someWarningsTwo]);
	const onNewWindowClick = () => {
		// console.log('new window clicked');
	};
	if (!warnings) {
		return null;
	}
	const warningsObj = randomWarnings();

	return (
		<Layout
			direction="column"
			nowrap
			fullWidth
			gap="xs"
			style={{padding: '0px'}}
		>
			{(Object.keys(warningsObj) as (keyof typeof warningsObj)[]).map((key, index) =>
				<StyledUnifonWarningLayout key={key} $delay={index}>
					<StyledUnifonWarningDiv nowrap $delay={index}>
						<WarningIcon size="lg" color="white"/>
						<StyledUnifonWarningText>
							{warningsObj[key]}
						</StyledUnifonWarningText>
						<IconButton
							onClick={onNewWindowClick}
							size="sm"
						>
							<NewWindowIcon customSize={20} color="white" />
						</IconButton>
					</StyledUnifonWarningDiv>
				</StyledUnifonWarningLayout>
			)}
			{/* {
				Object.keys(randomWarnings()).map((key, index) =>
					<StyledUnifonWarningLayout key={key} $delay={index}>
						<StyledUnifonWarningDiv nowrap $delay={index}>
							<WarningIcon size="lg" color="white"/>
							<StyledUnifonWarningText>
								{someWarnings[key]}
							</StyledUnifonWarningText>
							<IconButton
								onClick={onNewWindowClick}
								size="sm"
							>
								<NewWindowIcon customSize={20} color="white" />
							</IconButton>
						</StyledUnifonWarningDiv>
					</StyledUnifonWarningLayout>,
				)
			} */}
		</Layout>
	);
}

export default CustomerWarnings;
